<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <i :class="classIcon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </a>
  </div>
  <div v-else @click="clickHandler">
    <router-link v-if="url" :to="url" :class="classList">
      <i :class="classIcon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </router-link>
    <a v-else :class="classList" class="disabledNavRoute">
      <i :class="classIcon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </a>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList() {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    classIcon() {
      return [
        'nav-icon',
        'fa',
        'mr-2',
        this.icon
      ]
    },
    linkVariant() {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses() {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink() {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    clickHandler(event) {
      // console.log(event);
      // console.log("navLink Clicked");
      $(".nav-dropdown").removeClass("open");
      $(".nav-dropdown").removeClass("acitve");
      // console.log(event.path[6]);
    
      setTimeout(function() {
   let elements = event.path;
   // console.log(elements);
      for (var i = 3; i < 8;i++) {
            let index =  $.inArray('nav-dropdown',elements[i].classList);
            // console.log('Nav-dropdown: '+index);
            if(index >0){
              elements[i].classList.add('open');
              elements[i].classList.add('active');
          // console.log(elements[i].classList);  
            }
      }
      // console.log($(".nav-dropdown"));
      }, 150);
   


    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Sidebar/SidebarNavLink.vue